import { render, staticRenderFns } from "./HistoryOrder.vue?vue&type=template&id=c6889cb0&"
import script from "./HistoryOrder.vue?vue&type=script&lang=js&"
export * from "./HistoryOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports